import './stepper.scss';

import { ReactNode } from 'react';

import useProgressStore from '../../store/progressStore/useProgressStore';
import { CheckBoxIcon } from '../Icons/CheckBoxIcon';
import { CheckBoxOutlineBlankIcon } from '../Icons/CheckBoxOutlineBlankIcon';
import { StepperProps } from './types/StepperProps';

export const Stepper = ({
  steps,
  testId,
  titleTestId,
}: StepperProps): ReactNode => {
  const { isLastStep } = useProgressStore();
  const activeStep = steps.findIndex((step): boolean => !step.completed);

  return (
    <ol className="stepper" data-testid={testId}>
      {steps.map((step, index): ReactNode => {
        const active = index === activeStep;
        const stepClassNames = [
          'stepper-step',
          active && 'stepper-step-active',
          step.completed && 'stepper-step-completed',
          isLastStep(step) && 'stepper-step-final',
        ]
          .filter(Boolean)
          .join(' ');

        return (
          <li
            aria-current={active ? 'step' : undefined}
            className={stepClassNames}
            key={step.title}
          >
            {index > 0 && <span className="stepper-connector" />}
            <span className="stepper-label">
              <span className="stepper-icon">
                {step.completed ? (
                  <CheckBoxIcon flush />
                ) : (
                  <CheckBoxOutlineBlankIcon flush />
                )}
              </span>
              <span
                className="stepper-title"
                data-testid={titleTestId ? titleTestId(index) : undefined}
              >
                {step.title}
              </span>
            </span>
            <div className="stepper-content">
              <div className="stepper-description">{step.description}</div>
            </div>
          </li>
        );
      })}
    </ol>
  );
};
